import React from 'react'
import PropTypes from 'prop-types'
import { AgreementDetailsDisclosure } from '../components'
import { isEmpty } from 'lodash'
import { AccountAudience } from 'config/portal'

const propTypes = {
  agreementAudience: PropTypes.string.isRequired,
  planSponsorCompany: PropTypes.object,
  planSponsorContact: PropTypes.object,
  displayPlanEinValue: PropTypes.string,
  TPACompany: PropTypes.object,
  TPAContact: PropTypes.PropTypes.object,
  consultantCompany: PropTypes.object,
  consultantContact: PropTypes.PropTypes.object,
  recordKeeperCompany: PropTypes.PropTypes.object,
  recordKeeperContact: PropTypes.PropTypes.object,
  NoDetailsProvidedCard: PropTypes.func.isRequired,
}

const defaultProps = {}

function getTPAOrConsultantDetails({
  agreementAudience,
  TPACompany,
  TPAContact,
  consultantCompany,
  consultantContact,
}) {
  const hasTPADetails = !isEmpty(TPACompany) && !isEmpty(TPAContact)
  const hasConsultantDetails =
    !isEmpty(consultantCompany) && !isEmpty(consultantContact)
  if (hasTPADetails) {
    if (agreementAudience === 'Consultant') {
      return {
        toggleText: 'Consultant details',
        sectionName: 'Consultant',
        companyDetails: TPACompany,
        contactDetails: TPAContact,
      }
    }
    if (
      agreementAudience === 'TPA' ||
      agreementAudience === AccountAudience.RECORDKEEPER ||
      agreementAudience === AccountAudience.PLAN_FIDUCIARY
    ) {
      return {
        toggleText: 'TPA details',
        sectionName: 'TPA',
        companyDetails: TPACompany,
        contactDetails: TPAContact,
      }
    }
    return null
  }
  if (hasConsultantDetails) {
    if (agreementAudience === 'TPA') {
      return {
        toggleText: 'TPA details',
        sectionName: 'TPA',
        companyDetails: consultantCompany,
        contactDetails: consultantContact,
      }
    }
    if (agreementAudience === 'Consultant') {
      return {
        toggleText: 'Consultant details',
        sectionName: 'Consultant',
        companyDetails: consultantCompany,
        contactDetails: consultantContact,
      }
    }
    return null
  }
  return null
}
function PlanSponsorSection({
  planSponsorCompany,
  planSponsorContact,
  displayPlanEinValue,
  NoDetailsProvidedCard,
}) {
  if (isEmpty(planSponsorCompany) && isEmpty(planSponsorContact)) {
    return <NoDetailsProvidedCard sectionName="Plan Sponsor" />
  }
  return (
    <AgreementDetailsDisclosure
      toggleText="Plan sponsor details"
      sectionName="Plan Sponsor"
      companyDetails={planSponsorCompany}
      contactDetails={planSponsorContact}
      planEIN={displayPlanEinValue}
    />
  )
}
PlanSponsorSection.propTypes = {
  planSponsorCompany: PropTypes.object,
  planSponsorContact: PropTypes.object,
  displayPlanEinValue: PropTypes.string,
  NoDetailsProvidedCard: PropTypes.func.isRequired,
}

function TPAOrConsultantSection({
  agreementAudience,
  TPACompany,
  TPAContact,
  consultantCompany,
  consultantContact,
  NoDetailsProvidedCard,
}) {
  const details = getTPAOrConsultantDetails({
    agreementAudience,
    TPACompany,
    TPAContact,
    consultantCompany,
    consultantContact,
  })
  if (!details) {
    return <NoDetailsProvidedCard sectionName="TPA or Consultant" />
  }
  return <AgreementDetailsDisclosure {...details} />
}

TPAOrConsultantSection.propTypes = {
  agreementAudience: PropTypes.string.isRequired,
  TPACompany: PropTypes.object,
  TPAContact: PropTypes.object,
  consultantCompany: PropTypes.object,
  consultantContact: PropTypes.object,
  NoDetailsProvidedCard: PropTypes.func.isRequired,
}

function RecordkeeperSection({
  recordKeeperCompany,
  recordKeeperContact,
  NoDetailsProvidedCard,
}) {
  if (isEmpty(recordKeeperCompany) && isEmpty(recordKeeperContact)) {
    return <NoDetailsProvidedCard sectionName="Recordkeeper" />
  }
  return (
    <AgreementDetailsDisclosure
      toggleText="Recordkeeper details"
      sectionName="Recordkeeper"
      companyDetails={recordKeeperCompany}
      contactDetails={recordKeeperContact}
    />
  )
}
RecordkeeperSection.propTypes = {
  recordKeeperCompany: PropTypes.object,
  recordKeeperContact: PropTypes.object,
  NoDetailsProvidedCard: PropTypes.func.isRequired,
}
function AgreementDetailsSection({
  agreementAudience,
  planSponsorCompany,
  planSponsorContact,
  displayPlanEinValue,
  TPACompany,
  TPAContact,
  consultantCompany,
  consultantContact,
  recordKeeperCompany,
  recordKeeperContact,
  NoDetailsProvidedCard,
}) {
  return (
    <div className="optional-section">
      <div className="accordion-container">
        <PlanSponsorSection
          planSponsorCompany={planSponsorCompany}
          planSponsorContact={planSponsorContact}
          displayPlanEinValue={displayPlanEinValue}
          NoDetailsProvidedCard={NoDetailsProvidedCard}
        />
        <TPAOrConsultantSection
          agreementAudience={agreementAudience}
          TPACompany={TPACompany}
          TPAContact={TPAContact}
          consultantCompany={consultantCompany}
          consultantContact={consultantContact}
          NoDetailsProvidedCard={NoDetailsProvidedCard}
        />
        <RecordkeeperSection
          recordKeeperCompany={recordKeeperCompany}
          recordKeeperContact={recordKeeperContact}
          NoDetailsProvidedCard={NoDetailsProvidedCard}
        />
      </div>
    </div>
  )
}
AgreementDetailsSection.propTypes = propTypes
AgreementDetailsSection.defaultProps = defaultProps

export default AgreementDetailsSection
